<template>
    <div class="export">
        <div @click="printChart()" class="export-download print"> {{$l('graphs/export/Print chart')}} </div>
        <hr>
        <div @click="downloadPNG()" class="export-download png-download"> {{$l('graphs/export/Download')}} PNG {{$l('graphs/export/image')}}  </div>
        <div @click="downloadJPEG()" class="export-download jpeg-download"> {{$l('graphs/export/Download')}} JPEG {{$l('graphs/export/image')}}  </div>
        <div @click="downloadPDF()" class="export-download pdf-download"> {{$l('graphs/export/Download')}} PDF  </div>
        <div @click="downloadSVG()" class="export-download svg-download"> {{$l('graphs/export/Download')}} SVG {{$l('graphs/export/image')}}  </div>
    </div>
</template>

<style>
.export{
    line-height: 35px;
    text-align: center;
    cursor: default;
}
.export-download:hover{
    background-color:#E1E5EC;
}
</style>


<script>
import * as utils from '../../common/utils'
export default {
    props:['chart'],
    methods: {
        printChart: function(){
            this.chart.chart.print();
        },
        downloadPNG: function(){
            var file_name = "chart_PNG"
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear()+"-"+(date.getMonth() + 1)+"-"+utils.doubleDigit(date.getDate())+"-"+utils.doubleDigit(date.getHours()-1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type:"image/png",
            })
        },
        downloadJPEG: function(){
            var file_name = "chart_JPEG"
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear()+"-"+(date.getMonth() + 1)+"-"+utils.doubleDigit(date.getDate())+"-"+utils.doubleDigit(date.getHours()-1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type:"image/jpeg",
            })
        },
        downloadPDF: function(){
            var file_name = "chart_PDF"
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear()+"-"+(date.getMonth() + 1)+"-"+utils.doubleDigit(date.getDate())+"-"+utils.doubleDigit(date.getHours()-1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type:"application/pdf",
            })
        },
        downloadSVG: function(){
            var file_name = "chart_SVG"
            if (this.chart.chart.xAxis[0].dataMin > 0) {
                var date = new Date(this.chart.chart.xAxis[0].dataMin);
                file_name = date.getFullYear()+"-"+(date.getMonth() + 1)+"-"+utils.doubleDigit(date.getDate())+"-"+utils.doubleDigit(date.getHours()-1);
            }
            this.chart.chart.exportChart({
                filename: file_name,
                type:"image/svg",
            })
        }
    }
}
</script>




// WEBPACK FOOTER //
// ExportGraph.vue?5b08c8d6